// extracted by mini-css-extract-plugin
module.exports = {"wechatQrcodeContent":"DiscordBtn_wechatQrcodeContent__HCPuo","product-item":"DiscordBtn_product-item__fZZww"};